export default __webpack_public_path__ + "static/media/infoBlue.b4e8c2ac.svg";